import MypageRateContainer from './MypageRateContainer';
export default MypageRateContainer;
